import React from 'react';
interface BilingualTextProps {
  en: string;
  ar: string;
  className?: string;
  subtle?: boolean;
  reverse?: boolean;
}
export function BilingualText({
  en,
  ar,
  className = '',
  subtle = false,
  reverse = false
}: BilingualTextProps) {
  return <div className={`flex flex-col ${className} ${reverse ? 'items-end text-right' : ''}`} data-id="element-55">
      <span className="font-medium leading-tight" data-id="element-56">{en}</span>
    </div>;
}